import {
  EnumLangType,
  EnumEmailTemplateType
} from "./types/globals";


export const LANGS = {
  FR: "fr",
  EN: "en"
} satisfies { [key: string]: EnumLangType };

export const EMAIL_TEMPLATES = {
  PWD_CHANGED: "pwd-changed",
  FORGOT_PASSWORD: "forgot-pwd",
  ADMIN_NEW_EVENT: "admin-new-event",
  ADMIN_CREATED_USER: "admin-created-user",
  ADMIN_CONTACT_US: "admin-contact-us",
  ADMIN_SIGNALED_EVENT: "admin-signaled-event",
  VERIFY_EMAIL: "verify-email",
  WELCOME_VIEWER: "welcome-viewer",
  WELCOME_EVENT_MANAGER: "welcome-event-manager",
  EVENT_REMINDER: "event-reminder"
} satisfies { [key: string]: EnumEmailTemplateType };


export const CA_PROVINCES = {
  "AB": "Alberta",
  "BC": "British Columbia",
  "MB": "Manitoba",
  "NB": "New Brunswick",
  "NL": "Newfoundland and Labrador",
  "NT": "Northwest Territories",
  "NS": "Nova Scotia",
  "NU": "Nunavut",
  "ON": "Ontario",
  "PE": "Prince Edward Island",
  "QC": "Québec",
  "SK": "Saskatchewan",
  "YT": "Yukon Territory"
} as const;


export const USER_TYPES = {
  VIEWER: "viewer",
  EVENT_MANAGER: "event-manager"
} as const;

export const FRONTEND_TYPES = {
  MOBILE_APP: "MobileApp",
  WEBSITE: "Website"
} as const;

export const DEVICE_TYPES = {
  WEB:"web",
  IOS: "ios",
  ANDROID: "android"
} as const;

export const USER_LOG_TYPES = {
  LOGIN: "login",
  SIGNUP: "signup",
  FORGOT_PASSWORD: "forgot-password",
  EVENT_SIGNALED: "event-signaled",
  EVENT_VIEWED: "event-viewed",
  EVENT_CLICKED: "event-clicked",
  LOCATION_CHANGED: "location-changed",
} as const
export const USER_PLAN_TYPES = {
  COMPLETE_MONTHLY: "complete",//full plan
  COMPLETE_YEARLY: "complete-yearly",//full plan
  FREE_COMPLETE: "free-complete",//give by admin
  UNIT: "unit",//not valid anymore
  TRIAL: "trial",
  CANCELED: "canceled"
} as const;
